import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import SEO from '@/components/base/SEO';
import ScrollToTop from '@/components/base/ScrollToTop';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import ProductShowcase from './components/ProductShowcase';
import Advantages from './components/Advantages';
import GroupBuy from './components/GroupBuy';
import ArticleRecommend from './components/ArticleRecommend';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '瓜瓜基地',
  url: 'https://guaguabase.com',
  description: '瓜瓜基地是您信赖的优质瓜果直采平台，从产地到餐桌，严选西瓜、哈密瓜、香瓜等各类时令瓜果，保证新鲜甜蜜。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://guaguabase.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '瓜瓜基地',
  url: 'https://guaguabase.com',
  description: '正宗瓜果直采平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '农展馆南路12号瓜瓜大厦',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <SEO />
      <JsonLd data={websiteSchema} />
      <JsonLd data={orgSchema} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ProductShowcase />
        <Advantages />
        <GroupBuy />
        <ArticleRecommend />
      </main>
      <Footer />
    </>
  );
}